import PropTypes from 'prop-types';

export default PropTypes.shape({
  isDirectory: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  fullPath: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  accessLevel: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  thumbSrc: PropTypes.string
});